//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";

// custom pages
import LoginParent from "./LoginParent";

export default function VerifyOTPParent(props) {
  return <LoginParent>{props.children}</LoginParent>;
}
